exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "progressbar {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%; }\n  progressbar .bar {\n    position: absolute;\n    height: 2px;\n    top: 50%;\n    margin-top: -1px;\n    left: 0;\n    right: 70px;\n    background-color: #f5f5f5; }\n    progressbar .bar .progress-current {\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      background-color: #00816a; }\n  progressbar .text {\n    position: absolute;\n    width: 70px;\n    height: 100%;\n    top: 0;\n    right: 0;\n    font-size: 14px;\n    color: #999999; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/common/progressbar/progressbar.scss
// module id = 672
// module chunks = 3